<ng-container rtBlock="sc-blog-list-page">
    <sc-page-header>
        <h1 slot="title" rtElem="title" i18n="@@navBlog">Блог</h1>
        <p slot="lead" rtElem="lead" i18n="@@blogPageLead">
            От замера комнаты до толщины ступени. Что значат параметры конструктора и какие нормы стоят за каждым числом.
        </p>

        <div slot="filters" rtElem="filters" role="group" aria-label="Фильтр по группам" i18n-aria-label="@@blogFilterAria">
            <button
                type="button"
                rtElem="filter"
                qa-dataid="blog-filter"
                rtButton
                i18n="@@blogFilterAll"
                [rtMod]="{ active: activeRubric() === null }"
                [attr.aria-pressed]="activeRubric() === null"
                (click)="setFilter(null)">
                Все
            </button>
            @for (rubric of rubrics(); track rubric) {
                <button
                    type="button"
                    rtElem="filter"
                    qa-dataid="blog-filter"
                    rtButton
                    [rtMod]="{ active: activeRubric() === rubric }"
                    [attr.aria-pressed]="activeRubric() === rubric"
                    (click)="setFilter(rubric)">
                    {{ rubric }}
                </button>
            }
        </div>
    </sc-page-header>

    <section rtElem="list" aria-label="Статьи" i18n-aria-label="@@blogListAria" [attr.aria-busy]="loading()">
        @if (loading()) {
            @for (slot of skeletonSlots; track slot) {
                <div rtElem="skeleton" qa-dataid="blog-card-skeleton" aria-hidden="true">
                    <div rtElem="skeleton-image">
                        <rt-skeleton-wrapper qa-skip isLoading width="100%" height="100%" />
                    </div>
                    <div rtElem="skeleton-body">
                        <rt-skeleton-wrapper qa-skip isLoading width="88px" height="20px" />
                        <rt-skeleton-wrapper qa-skip isLoading width="70%" height="22px" />
                        <rt-skeleton-wrapper qa-skip isLoading width="100%" height="14px" />
                        <rt-skeleton-wrapper qa-skip isLoading width="85%" height="14px" />
                    </div>
                </div>
            }
        } @else {
            @for (card of filteredCards(); track card.article.id) {
                <sc-blog-article-card
                    qa-dataid="blog-list-card"
                    topLevel
                    [slug]="card.article.slug"
                    [path]="card.article.path"
                    [groupLabel]="card.rubric"
                    [title]="card.article.title"
                    [description]="card.article.description"
                    [imageSrc]="card.article.imageSrc"
                    [imageSrcset]="card.article.imageSrcset" />
            } @empty {
                <p i18n="@@blogListEmpty">Статей пока нет.</p>
            }
        }
    </section>
</ng-container>
